import t from 'tcomb';
import jsdk from '../../jsdk';
import UUID from '../../web/domain/UUID';
import Checkboxes_Style from '../../web/domain/style/Checkboxes_Style';
import Checkboxes_Other from '../../web/domain/Checkboxes_Other';
import get_bundle from '../../web/domain/get_bundle';
import Validation from '../../web/domain/Validation';
import Arr_Schema from '../../web/domain/Arr_Schema';

const Checkboxes_Input = t.struct({
  id: UUID,
  style: Checkboxes_Style,
  options: t.list(t.tuple([t.Str, t.Str, t.maybe(t.Bool)])),
  schema: Arr_Schema,
  other: t.maybe(Checkboxes_Other),
  other_label: t.maybe(t.String)
}, 'Checkboxes_Input');

/*
export default function Checkboxes_Input(id, style, options, schema, other) {
  jsdk.assert(jsdk.UUID.is(id));
  jsdk.assert(Checkboxes_Style.is(style));
  jsdk.assert(jsdk.List(jsdk.Tuple([jsdk.Str, jsdk.Str, jsdk.Maybe(jsdk.Bool)])).is(options));
  jsdk.assert(jsdk.Arr_Schema.is(schema));
  jsdk.assert(jsdk.Maybe(Checkboxes_Other).is(other));

  this.type = 'reducer/checkboxes';
  this.id = id;
  this.style = style;
  this.options = options;
  this.schema = schema;
  this.other = other;
  return jsdk.freeze(this);
}

Checkboxes_Input.is = function(x) {
  return x instanceof Checkboxes_Input;
};

Checkboxes_Input.of = function(x) {
  jsdk.assert(jsdk.Obj.is(x));
  return new Checkboxes_Input(
    jsdk.UUID.of(x.id),
    Checkboxes_Style.of(x.style),
    jsdk.List(jsdk.Tuple([jsdk.Str, jsdk.Str, jsdk.Maybe(jsdk.Bool)])).of(x.options),
    jsdk.Arr_Schema.of(x.schema),
    jsdk.Maybe(Checkboxes_Other).of(x.other)
  );
};
*/

Checkboxes_Input.prototype.focus = function() {

  // se l'utente ha scelto l'opzione altro non metto il focus perchè lo perderebbe la textbox
  // altrimenti metto il focus sulla prima checkbox

  if (!(this.other && $('#' + this.other.option_id).is(':checked'))) {
    $('#' + this.id + ' input[type=checkbox]:nth(0)').focus();
  }
};

Checkboxes_Input.prototype.block_but = function(id) {
  this.options.forEach(function(option) {
    if (option[0] !== id) {
      $('#' + option[0])
        .prop('disabled', true)
        .prop('checked', false);
    }
  });
  if (this.other) {
    $('#' + this.other.option_id)
      .prop('disabled', true)
      .prop('checked', false);
    $('#' + this.other.textbox_id)
      .prop('disabled', true)
      .val('');
  }
};

Checkboxes_Input.prototype.unblock = function() {
  $('#' + this.id + ' input[type=checkbox]').prop('disabled', false);
  if (this.other) {
    $('#' + this.other.textbox_id).prop('disabled', false);
  }
};

Checkboxes_Input.prototype.start = function() {
  var self = this;
  $('#' + this.id)
    .on('change', 'input[type=checkbox]', function() {
      var is_exclusive = $(this).attr('is_exclusive') === 'true';
      if (is_exclusive) {
        var is_checked = $(this).is(':checked');
        if (is_checked) {
          var id = $(this).attr('id');
          self.block_but(id);
        } else {
          self.unblock();
        }
      }
    });
};

Checkboxes_Input.prototype.stop = function() {
  $('#' + this.id).off();
};

Checkboxes_Input.prototype.to_html = function(value, locale) {

  var self = this;
  var bundle = get_bundle(locale).reducer;

  var options = this.options.slice();

  // Se c'è l'opzione altro aggiungo una option in ultima posizione
  if (this.other) {
    var other_option = [
      this.other.option_id,
      this.other_label || bundle.other
    ];
    options.push(other_option);
  }

  // I margini vanno sul contenitore
  var styles = jsdk.split_margins(this.style);

  // Converto le option in una tabella a due colonne
  // nella prima metto le checkbox, nella seconda le label
  var option_to_table_row = function(option) {
    return '<div class="group-input">' + jsdk.dom.checkbox({
        id: option[0],
        is_exclusive: option[2]
      }) + '</div>' +
      '<div class="group-label">' + option[1] + '</div>';
  };

  var attrs = {
    id: self.id,
    style: styles.other
  };

  var html = jsdk.dom.div(options.map(option_to_table_row).join(''), attrs);

  // Se c'è l'opzione altro aggiungo una textbox alla fine
  if (this.other) {
    html += jsdk.dom.textbox({
      id: this.other.textbox_id
    });
  }

  return jsdk.Form.wrap_input(this.id, html, styles.margins);
};

Checkboxes_Input.prototype.set_error = function(message) {
  $("#" + this.id + "_error").html(message);
};

Checkboxes_Input.prototype.value = function(locale) {
  //jsdk.assert(Locale.is(locale));
  //recupero i valori delle checkbox
  var option_values = this.options.map(function(option) {
    return [
      option[0],
      $('#' + option[0]).is(':checked')
    ];
  });
  if (this.other) { // se c'è l'opzione altro recupero il valore della checkbox altro
    option_values.push([
      this.other.option_id,
      $('#' + this.other.option_id).is(':checked')
    ]);
  }
  //calcolo quanti sono i true per la validazione
  var trues = option_values.filter(function(x) {
    return x[1] === true;
  });
  var validation = this.schema.validate(trues);

  if (validation.rule === null) {
    if (this.other && option_values[option_values.length - 1][1]) { // se l'utente ha selezionato anche l'opzione altro..
      var textbox_id = this.other.textbox_id;
      var textbox_value = $('#' + textbox_id).val(); // recupero il valore della textbox
      var textbox_validation = this.other.schema.validate(textbox_value); // valido la textbox
      if (textbox_validation.rule) { // se la textbox non va bene, gli metto il focus
        $('#' + textbox_id).focus();
        validation = textbox_validation;
      } else {
        // se è andato tutto bene, concateno i valori delle checkbox e della textbox
        option_values.push([
          textbox_id,
          textbox_validation.x
        ]);
        validation = new Validation({x: option_values});
      }
    } else {
      validation = new Validation({x: option_values});
    }
  }
  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
  return validation;
};

jsdk.Form.add_input('reducer/checkboxes', Checkboxes_Input);


export default Checkboxes_Input;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/form/reducer/Checkboxes_Input.js
 **/